import type { FrontendModule } from '@/lib/types'
import { CasesListPage } from './pages/CasesListPage'
import { CaseDetailPage } from './pages/CaseDetailPage'
import { MyCasesWidget } from './widgets/MyCasesWidget'

/**
 * Moduł `cases` — rejestr spraw i karta sprawy.
 *
 * Nawigacja NIE jest deklarowana tutaj: pochodzi z `/api/me/context`
 * (manifest backendu: grupa „SPRAWY", pozycja „Rejestr spraw", trasa `/sprawy`).
 */
export const casesModule: FrontendModule = {
  key: 'cases',
  routes: [
    { path: 'sprawy', element: <CasesListPage /> },
    { path: 'sprawy/:caseId', element: <CaseDetailPage /> },
  ],
  dashboardWidgets: [{ id: 'cases.my', column: 'side', order: 20, component: MyCasesWidget }],
}

export default casesModule
